import React from 'react';
import {ComboboxItem} from '@pb/kit-component-combo-box';
import {ALL_RESULTS} from '../constants';
import {ShowResults} from './switcher-types/show-results';
import {OnlyPageSize} from './switcher-types/only-page-size';

import type {SwitcherProps} from './typedef';

export const Switcher = (props: SwitcherProps) => {
    const {
        sizeSwitcherType,
        sizes,
        totalCount,
    } = props;

    const getSwitcherType = () => {
        switch (sizeSwitcherType) {
            case 'ONLY_PAGE_SIZE':
                return OnlyPageSize;
            case 'SHOW_RESULTS':
                return ShowResults;
            default:
                return null;
        }
    };

    const renderItem = (item: number, key: number, array: Array<number>) => {
        return totalCount > (array[key - 1] || ALL_RESULTS) ?
                <ComboboxItem caption={item === ALL_RESULTS ? 'All' : String(item)} value={item} key={key}/> :
            null;
    };

    const SwitcherType = getSwitcherType();

    if (SwitcherType) {
        return (
            <SwitcherType {...props}>
                {sizes.map(renderItem)}
            </SwitcherType>
        );
    }

    return null;
};
